import React from 'react';
import skylineMarkImage from '../../../shared/img/skyline-mark.svg';
import sitchBlueLogo from '../../../shared/img/sitch_blue_logo.png'

const PoweredBy = ({ name = 'Portal', img = '/' + skylineMarkImage, className }) => {
  return (
    <div className={`powered-by ${className}`}>
      <span className='powered-by-text'>
        Powered By:
      </span>
      <div className='product-title'>
        <img className='skyline-mark' src={'/' + sitchBlueLogo} alt='Sitch Logo' />
      </div>
    </div>
  );
};

export default PoweredBy;
